import '@/assets/css/style.scss';
if (import.meta.env.VITE_INCLUDE_COMMON === 'true') {
  import('@/assets/css/global-footer.css');
  import('@/assets/js/common/loadHeaderFooter.js').then(module => {
    const loadHeaderFooter = module.default;
    loadHeaderFooter();
  });
  import('@/assets/js/common/components/login.js');
}

import { createApp, ref, onMounted, computed } from './vue.esm-browser.prod.js';
import { soupData, reportData } from './data';
import './common/k-tools/k-tools.css';
import { KAnchor, KScrollTrigger, KTab, KScrollspy } from './common/k-tools/k-tools.js';
import LazyLoad from 'vanilla-lazyload';
// import Swiper bundle with all modules installed
import { Swiper } from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';
import { gsapAnimation, gsapAnimationUpdate } from './common/gsapAnimation';

const MAX_TIMEOUT = 2147483647; // 約 2^31-1 ms（約 24.85 天）

/**
 * 在 targetDate 到時為 element 加上 class
 * @param {Date} targetDate 目標時間（使用 local timezone，例如 new Date(2025,9,23,0,0,0)）
 * @param {string} className 要加入的 class 名稱
 */
function addClassAt(targetDate, className) {
  function doAdd() {
    console.log('add');
    $('.timeout,.schedule,.view,.vote__link').addClass(className);
  }

  function schedule() {
    const now = new Date();
    const ms = targetDate - now;

    if (ms <= 0) {
      // 已經到或過了目標時間 → 立刻加上
      doAdd();
      return;
    }

    if (ms <= MAX_TIMEOUT) {
      // 在可接受範圍內，直接 setTimeout
      setTimeout(doAdd, ms);
      console.log(`Scheduled addClass in ${ms} ms`);
    } else {
      // 太久了：先等一段（MAX_TIMEOUT），之後再次檢查（遞迴）
      // 這樣能避免超過 setTimeout 的上限
      setTimeout(() => {
        // 再次呼叫 schedule 以重新計算剩餘時間
        schedule();
      }, MAX_TIMEOUT);
      console.log(`Duration too long, will re-schedule after ${MAX_TIMEOUT} ms`);
    }
  }

  // 立即啟動排程（也會立即檢查是否已過時間）
  schedule();
}

const swiperHandler = {};
swiperHandler.vote = () => {
  const swiper = new Swiper('.vote .swiper', {
    allowTouchMove: false,
    slidesPerView: 1,
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: true,
    autoplay: {
      delay: 3000,
    },
    preloadImages: false,
    lazy: {
      loadPrevNext: true,
    },
  });
};
swiperHandler.soup = () => {
  const soupSwiperArray = [];
  function soupSwiperInit() {
    $('.soup__swiper').each((index, el) => {
      const paginationEl = $(el).find('.swiper-pagination')[0];
      const prevEl = $(el).find('.swiper-button-prev')[0];
      const nextEl = $(el).find('.swiper-button-next')[0];
      soupSwiperArray[index] = new Swiper(el, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        pagination: {
          el: paginationEl,
          type: 'fraction',
        },
      });
    });
  }

  function checkScreenWidth() {
    const viewWidth = window.innerWidth;
    if (viewWidth < 1000) {
      soupSwiperInit();
    } else {
      soupSwiperArray.forEach((item, index) => {
        if (soupSwiperArray[index]) {
          soupSwiperArray[index].destroy(true, true);
          soupSwiperArray[index] = null;
        }
      });
    }
  }
  checkScreenWidth();
  $(window).on('resize', checkScreenWidth);
};
swiperHandler.all = () => {
  swiperHandler.soup();
  swiperHandler.vote();
};

const pageInitial = () => {
  const lazyLoadInstance = new LazyLoad({});
  const anchor = new KAnchor('[k-anchor]');
  const scrollTrigger = new KScrollTrigger('[k-st]', {
    start: 'top 80%',
    // marker: true,
  });

  gsapAnimation();
  addClassAt(new Date(2025, 9, 23, 0, 0, 0), 'vote-after');
  addClassAt(new Date(2025, 9, 30, 0, 0, 0), 'published');
  swiperHandler.all();
};

// Vue
createApp({
  setup() {
    const soupDataRef = ref(soupData);
    // 把同 type 的分組
    const groupedSoup = computed(() => {
      return soupDataRef.value.reduce((acc, item) => {
        if (!acc[item.type]) acc[item.type] = [];
        acc[item.type].push(item);
        return acc;
      }, {});
    });
    const reportDataRef = ref(reportData);
    onMounted(() => {
      setTimeout(() => {
        pageInitial();
      }, 200);
    });
    return {
      soupDataRef,
      groupedSoup,
      reportDataRef,
    };
  },
}).mount('#main');
